import { ExclamationSvg } from '../svg/exclamation-svg'
import { Lang } from '../../translations/lang'

export const NotYetIcon = () => (
  <div className="flex flex-col items-center gap-[4px]">
    <ExclamationSvg />
    <p className="font-bold text-xs text-vixell-red">{Lang.notYet}</p>
  </div>
)
